var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.getSolutionMeta ? _vm.getSolutionMeta.name : "")+" "),_c('div',{staticClass:"view"},[_c('Sequence',{attrs:{"enableSelection":false,"protein":_vm.getSolution,"from":Number.NEGATIVE_INFINITY,"to":Number.POSITIVE_INFINITY,"colorBy":(acid) =>
          _vm.getSolutionMeta.sequencePreview[acid.index] == 'I'
            ? '#179BAC'
            : '#AC2817'}})],1),_c('div',{staticClass:"downloads"},[_c('TextLabelButton',{on:{"click":_vm.userDownloadSelectedSolution}},[_vm._v("Download solution PDB")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }